<app-loadable-content [loadingController]="userLoadingController" (onRetry)="loadUser()">
    <app-title>{{ headerText }}</app-title>
</app-loadable-content>
